import type { LandingPersona } from '@/hooks/useLandingPersona'

interface Props {
  persona: LandingPersona
}

const STEPS = [
  {
    title: 'Pick a plan',
    body: 'Solo, Pro, or Empire. Activate in under 60 seconds with Stripe — no contracts, no setup fees.',
  },
  {
    title: 'Connect your data',
    body: 'Plug in your Facebook Ads and Stripe, and connect your Google account so Jarvis can triage your own inbox and read your calendar. Your data stays in your own Azure tenant.',
  },
  {
    title: 'Get your number',
    body: 'A dedicated phone number is provisioned. Save it in your contacts — that’s your line to your data.',
  },
  {
    title: 'Call in, anytime',
    body: 'Ask what’s happening, get the answer out loud. Briefings, ad performance, MRR — wherever you are.',
  },
]

export default function LandingHowItWorks({ persona }: Props) {
  return (
    <section className="lp-section" id="how" style={{ background: 'rgba(255,255,255,0.012)' }}>
      <div className="lp-container">
        <div className="lp-section-header">
          <div className="lp-eyebrow">From zero to live</div>
          <h2>
            Four steps. <span style={{ color: persona.primary }}>Five minutes.</span>
          </h2>
          <p className="lp-subtitle">
            No long onboarding, no integration calls, no “solutions engineer.” Sign up,
            connect, and your AI is on the line.
          </p>
        </div>

        <div className="lp-steps">
          {STEPS.map((s) => (
            <div key={s.title} className="lp-card lp-step">
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
